// extracted by mini-css-extract-plugin
module.exports =  {"time":"LogMessageTime__time--Jr","highlight":"LogMessageTime__highlight--h5"};